import { render, staticRenderFns } from "./LoadingDefault.vue?vue&type=template&id=385fbe43&"
import script from "./LoadingDefault.vue?vue&type=script&lang=js&"
export * from "./LoadingDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports